<li ngbDropdown class="nav-item dropdown-notification mr-25">
	<a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown">
		<i class="ficon position-relative" data-feather="bell"></i>
		@if (unreadCount > 0) {
			<span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">{{
				unreadCount > 99 ? '99+' : unreadCount
			}}</span>
		}
	</a>

	<ul ngbDropdownMenu aria-labelledby="navbarNotificationDropdown" class="dropdown-menu dropdown-menu-media dropdown-menu-right">
		<!-- Header -->
		<li class="dropdown-menu-header">
			<div class="dropdown-header d-flex align-items-center">
				<h4 class="notification-title mb-0 mr-auto">{{ 'notification_notifications' | translate }}</h4>
				@if (unreadCount > 0) {
					<div class="badge badge-pill badge-light-primary">
						{{ unreadCount }} {{ (unreadCount === 1 ? 'notification_new_single' : 'notification_new_multiple') | translate }}
					</div>
				}
			</div>
		</li>

		<!-- Lista -->
		<li class="scrollable-container media-list">
			@if (notifications.length > 0) {
				@for (n of notifications; track n) {
					<div class="d-flex notification-item" [class.unread]="!n.read_at" (click)="markRead(n.id, n.read_at)">
						<div class="media d-flex align-items-start w-100">
							<div class="media-left mr-1">
								<div class="avatar avatar-sm" [ngClass]="typeClass(n.type)">
									<div class="avatar-content">
										<i class="avatar-icon font-small-3" [attr.data-feather]="typeIcon(n.type)"></i>
									</div>
								</div>
							</div>
							<div class="media-body overflow-hidden">
								<p class="media-heading mb-0 font-small-3" [class.font-weight-bolder]="!n.read_at">
									{{ n.title | translate }}
									@if (n.data?.reportTitle) {
										: {{ n.data.reportTitle }}
									}
								</p>
								@if (n.body) {
									<small class="notification-text clamped d-block" [title]="localizeBody(n.body)">{{ localizeBody(n.body) }}</small>
								}
								<small class="notification-text text-muted d-flex align-items-center justify-content-between">
									<span>{{ n.created_at | localizedDate: 'dayMonthTime' }}</span>
									@if (n.data?.link) {
										<a [routerLink]="n.data.link" class="ml-1 font-weight-bold" (click)="$event.stopPropagation()"
											>{{ 'notification_go_to' | translate }} &rarr;</a
										>
									}
								</small>
							</div>
							<div class="media-meta d-flex align-items-center ml-1">
								@if (!n.read_at) {
									<span class="bullet bullet-sm bullet-primary mr-50"></span>
								}
								<button
									class="btn btn-icon btn-sm btn-flat-danger p-0 notification-delete"
									[title]="'common_btn_delete' | translate"
									(click)="deleteNotification(n.id, $event)">
									<i data-feather="x" class="font-small-3"></i>
								</button>
							</div>
						</div>
					</div>
				}
			} @else {
				<div class="d-flex flex-column align-items-center justify-content-center py-3 text-muted">
					<i data-feather="bell-off" class="mb-50"></i>
					<small>{{ 'notification_empty' | translate }}</small>
				</div>
			}
		</li>

		<!-- Footer -->
		<li class="dropdown-menu-footer">
			<div class="d-flex">
				@if (unreadCount > 0) {
					<button class="btn btn-primary flex-grow-1 waves-effect waves-light mr-50" (click)="markAllRead()">
						{{ 'notification_mark_all_read' | translate }}
					</button>
				}
				<button class="btn btn-outline-secondary flex-grow-1 waves-effect waves-light" (click)="goToAllNotifications()">
					{{ 'notification_view_all' | translate }}
				</button>
			</div>
		</li>
	</ul>
</li>
